import { Link, NavLink } from 'react-router-dom';
import styles from '../../css/rulesAndPolicy.module.css';
import Bars from '../Bars';
import { FiArrowLeft } from 'react-icons/fi';

function AboutMe() {
  return (
    <>

      <NavLink to="/info" className="backLink userSelectNone">
        <FiArrowLeft className="backIcon" />
        <span>Powrót</span>
      </NavLink>

      <div className={`${styles.rulesAndPolicyConteiner} userSelectNone`}>
      
        <h3 className='h3-header userSelectNone'  aria-label="O mnie">
          <img src="/logo/logoApp.png" alt="logo" className='logo'  /> O mnie
        </h3>

        <p>
          Cześć! Mam na imię Mateusz. Od kilku lat jedną z moich pasji są górskie wędrówki — głównie po Tatrach. Poza tym lubię jeździć na rowerze, biegać i chodzic na siłownię oraz jak widać... programować.
        </p>

        <p>
          Pomyślałem o stworzeniu tej platformy, aby ułatwić ludziom wspólne podróże i wyprawy w góry — bez rejestracji, tanio, prosto i wygodnie. Można też sprawdzić tutaj pogodę. 
        </p>

        <p>
          W planach mam rozbudowę strony o m.in dodanie pomiaru aktualnej wysokośći czy możliwość darmowej rejestracji i logowania, aby każdy mógł dzielić się z innymi swoimi górskimi przygodami, zdjęciami i różnościami górskimi. 
        </p>

        <p>
          Jeśli chcesz mnie zmotywować do dalszego rozwoju projektu, możesz postawić mi kawę ☕ — będzie mi bardzo miło!
        </p>

        <div className={styles.adminImageWrapper}> 
          <img src="/me/2.jpg" alt="me" className={styles.adminImage} />
          <img src="/me/3.jpg" alt="me" className={styles.adminImage} />
          <img src="/me/4.jpg" alt="me" className={styles.adminImage} />    
        </div>

        <div className={styles.contactAdmin}>
          <p><strong>Kontakt:</strong></p>
          <p>✉️ mateuszek9119@gmail.com</p>
          <p>📸 @ma_te_uusz</p>
        </div>

      </div>

      <p className='mycopyright userSelectNone'>
        © 2025 GórskaPodwózka — wszystkie prawa zastrzeżone. Autor: Mateusz
      </p>

      <Bars />

    </>
    
  );
}

export default AboutMe;
